$(function () {
    let lockPassword = true;
    $("#loginPageLockIcon").on("click", () => {
        lockPassword = !lockPassword;
        if (lockPassword) {
            $("#loginPageLockIcon i").attr("class", "fas fa-eye-slash");
            $("#loginPassword").attr("type", "password");
        } else {
            $("#loginPageLockIcon i").attr("class", "fas fa-eye");
            $("#loginPassword").attr("type", "text");
        }
    });
});
